export const isProduction = () => window.location.host === 'app.specterr.com';
